// src/pages/SupplierList.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios';
import { 
  Container, Paper, Typography, Button, Table, TableHead, TableRow, 
  TableCell, TableBody, IconButton, Box, CircularProgress 
} from "@mui/material";
import { 
  Delete as DeleteIcon, Edit as EditIcon, PersonAdd as PersonAddIcon, 
  LocalShipping as LocalShippingIcon, FileDownload as DownloadIcon 
} from "@mui/icons-material";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default function SupplierList() {
  const navigate = useNavigate();
  const companyId = localStorage.getItem('companyId');
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    setLoading(true);
    axios.get(`/Supplier/by-company/${companyId}`)
      .then(res => setSuppliers(res.data))
      .catch(err => console.error('❌ خطأ في تحميل الموردين:', err))
      .finally(() => setLoading(false));
  }, [companyId]);

  const deleteSupplier = id => {
    if (!window.confirm('❗ هل أنت متأكد من حذف هذا المورد؟')) return;
    axios.delete(`/Supplier/${id}`)
      .then(() => {
        setSuppliers(ss => ss.filter(s => s.id !== id));
        alert('🗑️ تم حذف المورد');
      })
      .catch(() => alert('❌ حدث خطأ أثناء الحذف'));
  };

  const exportToExcel = () => {
    const data = suppliers.map((s, idx) => ({
      'رقم': idx + 1, 'الاسم': s.name, 'الرقم الضريبي': s.taxNumber || '-', 'الجوال': s.mobile || '-'
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'الموردين');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `suppliers_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }} dir="rtl">
      {/* هيدر الصفحة العصري */}
      <Paper elevation={0} sx={{ p: 4, mb: 4, borderRadius: '24px', background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', color: 'white' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <LocalShippingIcon sx={{ fontSize: 40 }} />
            <Typography variant="h4" fontWeight="800">📋 إدارة الموردين</Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="outlined" onClick={exportToExcel} sx={{ color: 'white', borderColor: 'white', borderRadius: '12px' }} startIcon={<DownloadIcon />}>تصدير</Button>
            <Button variant="contained" onClick={() => navigate('/Supplier/new')} sx={{ bgcolor: 'white', color: '#1e293b', borderRadius: '12px', '&:hover': { bgcolor: '#e2e8f0' } }} startIcon={<PersonAddIcon />}>إضافة مورد</Button>
          </Box>
        </Box>
      </Paper>

      {/* جدول البيانات */}
      <Paper elevation={0} sx={{ p: 4, borderRadius: '24px', border: '1px solid #e2e8f0', overflowX: 'auto' }}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={5}><CircularProgress /></Box>
        ) : (
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8fafc' }}>
                {['#', 'الاسم', 'الرقم الضريبي', 'الجوال', 'إجراءات'].map(h => <TableCell key={h} align="center" sx={{ fontWeight: 'bold' }}>{h}</TableCell>)}
              </TableRow>
            </TableHead>
            <TableBody>
              {suppliers.map((s, idx) => (
                <TableRow key={s.id}>
                  <TableCell align="center">{idx + 1}</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>{s.name}</TableCell>
                  <TableCell align="center">{s.taxNumber || '-'}</TableCell>
                  <TableCell align="center">{s.mobile || '-'}</TableCell>
                  <TableCell align="center">
                    <IconButton color="warning" onClick={() => navigate(`/Supplier/${s.id}/edit`)}><EditIcon /></IconButton>
                    <IconButton color="error" onClick={() => deleteSupplier(s.id)}><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {suppliers.length === 0 && (
                <TableRow><TableCell colSpan={5} align="center" sx={{ py: 4 }}>لا يوجد موردين لعرضهم</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Container>
  );
}